const yi = {
  // Navigation
  'nav.dashboard': 'קאָנטראָל טאַבליצע',
  'nav.calendar': 'קאַלענדאַר',
  'nav.statistics': 'סטאַטיסטיק',
  'nav.callLog': 'רוף זשורנאַל',
  'nav.habits': 'געוווינהייטן',
  'nav.settings': 'שטעלונגען',
  'nav.admin': 'פאַרוואַלטונג',
  'nav.signOut': 'אַרויסגיין',

  // App
  'app.title': 'זמן',
  'app.subtitle': 'CodeLab',

  // Auth
  'auth.login': 'אַרייַנלאָגירן',
  'auth.signup': 'רעגיסטרירן',
  'auth.email': 'בליצפּאָסט',
  'auth.password': 'פּאַראָל',
  'auth.fullName': 'פולער נאָמען',
  'auth.forgotPassword': 'פארגעסן פּאַראָל?',
  'auth.resetPassword': 'פּאַראָל באַנייַען',
  'auth.sendResetLink': 'שיקן באַנייַונג לינק',
  'auth.backToLogin': 'צוריק צו אַרייַנלאָגירן',
  'auth.resetEmailSent': 'אויב אַ קאָנטע עקזיסטירט פֿאַר דעם בליצפּאָסט, איז געשיקט געוואָרן אַ לינק.',
  'auth.newPassword': 'נייַער פּאַראָל',
  'auth.confirmPassword': 'באַשטעטיקן פּאַראָל',
  'auth.updatePassword': 'דערהייַנטיקן פּאַראָל',
  'auth.passwordUpdated': 'דער פּאַראָל איז דערהייַנטיקט. איר קענט זיך איצט אַרייַנלאָגירן.',

  // Dashboard
  'dashboard.todayStatus': 'הייַנטיקער סטאַטוס',
  'dashboard.morningReminder': 'פרימאָרגן דערמאָנונג',
  'dashboard.bedtimeReminder': 'שלאָפצייַט דערמאָנונג',
  'dashboard.streak': 'סעריע',
  'dashboard.currentStreak': 'איצטיקע סעריע',
  'dashboard.longestStreak': 'לענגסטע סעריע',
  'dashboard.zmanim': 'זמנים',
  'dashboard.sunsetIn': 'שקיעה אין',
  'dashboard.upcomingReminders': 'קומענדיקע דערמאָנונגען',
  'dashboard.weeklyBreakdown': 'וועכנטלעכער איבערבליק',
  'dashboard.monthlyTrend': 'חודשלעכע טענדענץ',

  // Statuses
  'status.onTime': 'אין צייַט',
  'status.early': 'פרי',
  'status.late': 'שפּעט',
  'status.missed': 'פארפאסט',
  'status.pending': 'ווארטן',
  'status.shabbat': 'שבת',
  'status.holiday': 'יום טוב',

  // Settings
  'settings.title': 'שטעלונגען',
  'settings.language': 'ווייַז שפּראַך',
  'settings.languageRegion': 'שפּראַך און געגנט',
  'settings.timezone': 'צייַט זאָנע',
  'settings.shabbatMode': 'שבת מאָדע',
  'settings.holidayMode': 'יום טוב מאָדע',
  'settings.save': 'היט שינויים',
  'settings.saved': 'שטעלונגען געהיט',

  // Common
  'common.loading': 'לאָדנדיק...',
  'common.today': 'הייַנט',
  'common.cancel': 'אַנולירן',
  'common.confirm': 'באַשטעטיקן',
  'common.close': 'פאַרמאַכן',
  'common.search': 'זוכן',
  'common.noData': 'קיין דאַטן נישט פאַראַן',

  // Jewish calendar
  'jewish.shabbatShalom': 'גוט שבת',
  'jewish.chagSameach': 'גוט יום טוב',
  'jewish.candleLighting': 'ליכט צינדן',
  'jewish.havdalah': 'הבדלה',
  'jewish.parshat': 'פרשת',
  'jewish.roshChodesh': 'ראש חודש',

  // Pricing
  'pricing.title': 'קלייַבט אויס אייַער פּלאַן',
  'pricing.subtitle': 'אויטאָמאַטישע דערמאָנונג רופן וואָס בויען טאַקע הרגלים.',
  'pricing.planName': 'פּערזענלעך',
  'pricing.price': '$7',
  'pricing.perMonth': '/אַ חודש',
  'pricing.trialNote': 'הייבט אָן מיט 7 טעג פרייַ פּרווון. אַנולירן ווען עס איז.',
  'pricing.feature.calls': 'טעגלעכע אויטאָמאַטישע דערמאָנונג רופן',
  'pricing.feature.habits': 'אַנלימיטיד הרגלים און צייַטפּלאַנז',
  'pricing.feature.streaks': 'סטריק טראַקינג און סטאַטיסטיק',
  'pricing.feature.zmanim': 'פול עברי קאַלענדאַר און זמנים',
  'pricing.feature.multilang': 'ענגליש, העברעיש און ייִדיש',
  'pricing.startTrial': 'הייבט אָן 7 טעג פרייַ פּרווון',
  'pricing.processing': 'ווייַטערלייטן...',

  // Subscription (settings)
  'subscription.title': 'אַבאָנעמענט',
  'subscription.status': 'סטאַטוס',
  'subscription.plan': 'פּלאַן',
  'subscription.renews': 'באַנייַט',
  'subscription.trialEnds': 'פּרווון ענדיקט',
  'subscription.cancelsOn': 'אַנולירט אויף',
  'subscription.manageBilling': 'פאַרוואַלטן בילינג',
  'subscription.subscribe': 'אַבאָנירן',
  'subscription.none': 'איר האָט נישט קיין אַקטיוו אַבאָנעמענט.',
  'subscription.status.active': 'אַקטיוו',
  'subscription.status.trialing': 'פּרווון',
  'subscription.status.past_due': 'נישט באַצאָלט',
  'subscription.status.canceled': 'אַנולירט',
  'subscription.status.incomplete': 'נישט פאַרטיק',
  'subscription.status.unpaid': 'נישט באַצאָלט',

  // Admin billing toggle
  'admin.billing.title': 'בילינג',
  'admin.billing.toggle': ' שטעל אויף באַצאָלטע אַבאָנעמענטן',
  'admin.billing.help': 'ווען אויס, די אַפּ איז אין גאַנצן פרייַ און רופן לויפן פֿאַר יעדער באַניצער. ווען אָן, בלויז אַבאָנענטן באַקומען רופן.',
  'admin.billing.on': 'אָן',
  'admin.billing.off': 'אויס',
};

export default yi;
